import { projectApi } from "api/project.api";
import { useState } from "react";
import { QueryParam } from "types/query";

export interface ProjectQuery extends QueryParam {}

interface UseProjectProps {
  initQuery: ProjectQuery;
}

export const useProject = ({ initQuery }: UseProjectProps) => {
  const [data, setData] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [query, setQuery] = useState<ProjectQuery>(initQuery);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await projectApi.findAll(query);
      setData(data.projects);
      setTotal(data.total);
    } finally {
      setLoading(false);
    }
  };

  return {
    Projects: data,
    totalProject: total,
    fetchProject: fetchData,
    loadingProject: loading,
    setQueryProject: setQuery,
    queryProject: query,
  };
};
